export {
  ADD_DEPENDENT_MODAL_TEST_ID,
  DEPENDENTS_TAB_TEST_ID,
  EMPLOYEE_PROFILE_FORM_TEST_ID,
  EMPLOYEE_PROFILE_TAB_TEST_ID,
} from 'components/common/add-employees/full-form/constants';

export const FULL_FORM_TABS_TEST_ID = 'imq-full-form-tabs-test-id';
export const FULL_FORM_SPINNER_TEST_ID = 'imq-full-form-spinner-test-id';
